define([
	"dojo/_base/declare",
	"csi/heading/Attribute"
], function(declare,Attribute) {

return declare(Attribute, {
		canLink: function() {
			// TA20922: Routing Group Name should not be displayed as a link in the properties view of the routing.
			return false;
		}
	});
});